import React from 'react';
import OpacityOutlinedIcon from '@mui/icons-material/OpacityOutlined';
import EstadoFinancieroShell, { fmtMoney } from './EstadoFinancieroShell';

/** Clave del programa para validar permisos (mismo patrón que FacturaPOS). */
export const PROGRAMA_ESTADO_FLUJO_EFECTIVO = 'estadoflujodeefectivo';

const columns = [
  { id: 'seccion', label: 'Sección', align: 'left', width: '22%' },
  { id: 'concepto', label: 'Concepto', align: 'left', width: '58%' },
  {
    id: 'monto',
    label: 'Monto',
    align: 'right',
    width: '20%',
    render: (v, row) => (row.es_titulo ? '' : `$${fmtMoney(v)}`),
  },
];

const EstadoDeFlujoDeEfectivo = () => (
  <EstadoFinancieroShell
    programa={PROGRAMA_ESTADO_FLUJO_EFECTIVO}
    title="Estado de Flujo de Efectivo"
    subtitle="Actividades de operación, inversión y financiamiento"
    reportTitle="Estado de Flujo de Efectivo"
    IconComponent={OpacityOutlinedIcon}
    endpoint="contabilidadbackend_estadoflujodeefectivo"
    columns={columns}
    emptyMessage="No hay movimientos de efectivo para el período seleccionado"
    mapResponseRows={(data) => data.lineas || data.filas || []}
    footerFromRows={(filas) => {
      const varEfectivo = filas.find((r) => r.es_variacion || r.es_total);
      if (!varEfectivo) return '';
      return `Variación neta de efectivo: $${fmtMoney(varEfectivo.monto)}`;
    }}
  />
);

export default EstadoDeFlujoDeEfectivo;
